'use client';
import { useState, useEffect } from 'react';

export interface UseWindowSize {
    width: number | undefined;
    height: number | undefined;
}

export function useWindowSize(): UseWindowSize {
    const [windowSize, setWindowSize] = useState<UseWindowSize>({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
}

export default useWindowSize;
